import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ApiService, UtilService } from 'src/app/shared/services';
import { environment } from 'src/environments/environment';
import { debounceTime } from 'rxjs';

@Component({
  selector: 'app-ngo-select',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, FormsModule, MatAutocompleteModule],
  templateUrl: './ngo-select.component.html',
  styleUrls: ['./ngo-select.component.scss']
})
export class NgoSelectComponent {

  private readonly api = inject(ApiService);
  private readonly util = inject(UtilService);

  @Input() formGroup: FormGroup;
  @Input() control: FormControl;
  @Input() controlKey: string = 'ngo';
  @Input() theme: string = 'safTheme';
  @Input() placeholder: string = 'Enter Name';
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() triggerOnBlur: EventEmitter<any> = new EventEmitter();

  searchControl: FormControl = new FormControl('');

  ngos: any[] = [];
  selected = '';
  isLoading = false;

  ngOnInit() {
    this.searchControl.valueChanges.pipe(
      debounceTime(300)
    ).subscribe(val => {
      if (val) {
        this.getNgos(val);
      } else {
        this.ngos = [];
        this.onSelect.emit('');
        this.selected = '';
      }
    });
  }

  ngAfterViewInit() {
    const preValue = this.control?.value;
    if (preValue) {
      this.searchControl.setValue(preValue);
      this.selected = preValue?.full_name;
      this.searchControl.disable();
    }
  }

  getNgos(key: any) {
    this.isLoading = true;
    if(key?.fname && typeof key !== 'string'){
      key = key?.fname;
    }
    const url = environment.APP.API_URLS.GET_NGOS + `?fname=${key}`;
    this.api.get(url).subscribe({
      next: (res: any) => {
        if (res?.data?.data?.length === 0) {
          this.control?.setErrors({ ngoNotFound: true });
        }
        this.isLoading = false;
        this.ngos = res?.data?.data || [];
      },
      error: (err: any) => {
        this.isLoading = false;
        this.ngos = [];
      }
    });
  }

  onBlur() {
    this.control.markAllAsTouched();
    this.triggerOnBlur.emit(this.searchControl.value);
  }

  displayFn(item: any): string {
    return item?.name || item?.full_name || '';
  }

  selectOption(option: any) {
    this.isLoading = false;
    this.selected = option?.full_name;
    this.searchControl.disable();
    this.onSelect.emit({ option, value: this.searchControl.value });
  }

  clear() {
    this.selected = '';
    this.searchControl.enable();
    this.searchControl.setValue('');
    setTimeout(() => {
      this.util.doc.getElementById(`input-${this.controlKey}`)?.focus()
    }, 10);
  }

}
